// extracted by mini-css-extract-plugin
export default {"mobile_nav_wrapper":"Ei","mobile_nav":"Fi","link":"Gi","link_name":"Hi","active":"Ii"};
    if(module.hot) {
      // 1713361640522
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  